"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var date = tslib_1.__importStar(require("date-fns"));
function normalizeUserDateInput(value, formatString) {
    if (formatString === void 0) { formatString = 'yyyy-MM-dd'; }
    var now = new Date();
    var userValue = new Date(value);
    if (date.isValid(userValue)) {
        if (userValue.getFullYear() === 2001) {
            userValue.setFullYear(now.getFullYear());
            if (userValue > now) {
                userValue.setFullYear(userValue.getFullYear() - 1);
            }
        }
        value = date.format(userValue, formatString);
    }
    else {
        value = date.format(now, formatString);
    }
    return value;
}
exports.normalizeUserDateInput = normalizeUserDateInput;
//# sourceMappingURL=date.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/date.js
// module id = sgM+
// module chunks = 0